import React from "react";

/**
 * Watercolour lemon branch — raster PNG (generated via Gemini Nano Banana).
 * Optional `flip` prop mirrors horizontally for right-corner placement.
 */
export const LemonBranchImg = ({ className = "", flip = false, alt = "" }) => (
  <img
    src={flip ? "/illustrations/lemon_branch_flip.png" : "/illustrations/lemon_branch.png"}
    alt={alt}
    aria-hidden={alt ? undefined : "true"}
    className={className}
    style={flip ? { transform: "scaleX(-1)" } : undefined}
    loading="lazy"
  />
);

/**
 * Watercolour Amalfi coast banner — raster PNG.
 */
export const AmalfiCoastImg = ({ className = "", alt = "" }) => (
  <img
    src="/illustrations/amalfi_coast.png"
    alt={alt}
    aria-hidden={alt ? undefined : "true"}
    className={className}
    loading="lazy"
  />
);
